import { render, staticRenderFns } from "./Catogory.vue?vue&type=template&id=def4c1ba&scoped=true"
import script from "./Catogory.vue?vue&type=script&lang=js"
export * from "./Catogory.vue?vue&type=script&lang=js"
import style0 from "./Catogory.vue?vue&type=style&index=0&id=def4c1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def4c1ba",
  null
  
)

export default component.exports